export const handleKeyStrokes = (event) => {
    if (event.key === 'Enter') {
        event.target.blur()
        return
    } else if (event.key === 'Delete') {
        event.stopPropagation();
    }
}